import * as React from 'react';
import { gql, useQuery } from '@apollo/client';
import IconButton from 'components/elements/IconButton';
import { GetPhotoshoot_photoshoot } from 'components/__generated__/GetPhotoshoot';
import PhotoshootMessage from 'components/elements/PhotoshootMessage';
import SharePhotoshootLink from 'components/elements/SharePhotoshootLink';
import { CURRENT_USER_FRAGMENT } from 'types/users';
import { GetCurrentUser } from 'components/__generated__/GetCurrentUser';
import './PhotoshootToolbar.scss';

const GET_CURRENT_USER = gql`
  query GetCurrentUser {
    me {
      ...CurrentUser
    }
  }
  ${CURRENT_USER_FRAGMENT}
`;

interface PhotoshootToolbarProps {
  children?: any;
  photoshoot: GetPhotoshoot_photoshoot;
  setSelectCompare?: (e: React.MouseEvent) => void;
}
const PhotoshootToolbar: React.FC<PhotoshootToolbarProps> = ({
  photoshoot,
  setSelectCompare,
}: PhotoshootToolbarProps) => {
  const { data: currentUserData } = useQuery<GetCurrentUser>(GET_CURRENT_USER);
  const isAdmin = currentUserData?.me?.isAdmin || false;
  return (
    <div className="PhotoshootToolbar">
      <div className="left-side">
        <PhotoshootMessage>{photoshoot.message}</PhotoshootMessage>
      </div>
      <div className="right-side">
        {photoshoot.isOwner || isAdmin ? (
          <SharePhotoshootLink photoshootId={photoshoot.id} />
        ) : (
          <div />
        )}
        {!!setSelectCompare && (
          <IconButton
            whiteBackground={false}
            icon="arrow-repeat"
            onClick={setSelectCompare}
          >
            Vertaa kuvia
          </IconButton>
        )}
      </div>
    </div>
  );
};
export default PhotoshootToolbar;
